import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography
} from "@mui/material";

const DuplicateAlertDialog = ({ open, handleClose, duplicates }) => {
  return (
    <Dialog open={open} onClose={() => handleClose(false)} maxWidth="md" fullWidth>
      <DialogTitle sx={{ color: "#d32f2f", fontWeight: "bold" }}>⚠️ Duplicate Entries Found</DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2, color: "#555" }}>
          The following entries have duplicate <strong>Aadhar</strong> or <strong>Contact Numbers</strong>:
        </Typography>

        <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
          <Table stickyHeader>
            <TableHead sx={{ backgroundColor: "#f8d7da" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Ref No</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Aadhar No</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Contact No</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Duplicate Of</TableCell> {/* NEW */}
              </TableRow>
            </TableHead>

            <TableBody>
              {duplicates.map((entry, index) => (
                <TableRow key={index} sx={{ backgroundColor: "#ffebee" }}>
                  <TableCell>{entry.refNo || "N/A"}</TableCell>
                  <TableCell>{entry.aadharNo1 || "N/A"}</TableCell>
                  <TableCell>{entry.contactNo1 || "N/A"}</TableCell>
                  <TableCell sx={{ fontStyle: "italic", color: "#616161" }}>
                    {entry.existingRefNo || "-"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => handleClose(false)} color="error">Cancel Upload</Button>
        <Button onClick={() => handleClose(true)} color="primary" variant="contained">
          Allow duplicates
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateAlertDialog;
